// orderDelete.js — who sees the trash button on a /backoffice/orders row.
//
// Spec: docs/specs/2026-10-07-bo-order-delete-guard-and-swal-success-ink-design.md §2.
//
// The trash button does not delete anything: `handleDelete` in
// views/Backoffice/OrderTables.vue opens the CANCEL-order modal. So a row that is
// already cancelled (140) or anywhere in the return family (141 returned,
// 142 claim, 143 returning) has nothing left for that button to do, and the owner
// asked for it to be gone (2026-10-07) — for every role, admin and owner included.
//
// Everything below the cancel-family rule is the component's previous role logic,
// unchanged (it used `!=`, so a numeric string such as "100" already matched 100;
// Number() keeps that).
//
// Vue-free on purpose, so it can be tested as a plain function
// (tests/unit/orderDelete.spec.js); OrderTables.vue#isAccessDeleleteOrder delegates
// here.

export const ORDER_STATUS_CANCEL_FAMILY_MIN = 140;

const EMPLOYEE_PAYMENT_STATUSES = [100, 111, 112];
const NEW_ORDER_STATUS = 100;

export function canDeleteOrder({
	orderStatus,
	isAdmin,
	isOwner,
	isEmployee,
	isAccessPayment,
	isAgent,
} = {}) {
	const status = Number(orderStatus);

	// Cancel / return family first, before any role. NaN (undefined, "", junk)
	// is not >= 140, so an unknown status falls through to the role rules.
	if (status >= ORDER_STATUS_CANCEL_FAMILY_MIN) return false;

	if (isAdmin) return true;
	if (isOwner) return true;
	if (isEmployee) {
		if (isAccessPayment) return EMPLOYEE_PAYMENT_STATUSES.includes(status);
		return status === NEW_ORDER_STATUS;
	}
	if (isAgent) return status === NEW_ORDER_STATUS;
	return true;
}
